module.exports = __webpack_public_path__ + "banner.496b7360aead69e5c887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = 845
// module chunks = 15